/* istanbul ignore file */
import { UpdateForm } from 'framework/form';
import usePresaleOpportunityService from 'domain/sales/opportunity/presale/request/shared/presaleRequestService';
import { useOpportunityId } from 'domain/shared/opportunity';
import UpdatePresaleLayout from 'domain/sales/opportunity/presale/request/shared/layout/UpdatePresaleLayout';
import { ENTITY_DOCUMENT_TYPE } from 'domain/sales/opportunity/shared/constants';
import { useCompositeDocumentStorageContext, useCompositeDocumentStorageService } from 'domain/shared/documentStorage';

const UpdatePresaleRequestForm = ({ getDataFunc, onCancel, ...props }: any) => {
  const opportunityId = useOpportunityId();
  const { updatePresaleRequest, getValidationSchema } = usePresaleOpportunityService();

  const { isDocumentStorageAvailable } = useCompositeDocumentStorageContext();
  const { commitDocument } = useCompositeDocumentStorageService(isDocumentStorageAvailable);

  return (
    <UpdateForm
      getDataFunc={getDataFunc}
      submitFormFunc={async (id, values) => {
        const artifactPath = values?.artifactPaths;
        const commitData = await commitDocument(artifactPath, ENTITY_DOCUMENT_TYPE.PRESALE_REQUEST_DOCUMENT);
        return updatePresaleRequest(opportunityId, id, { ...values, artifactPaths: commitData });
      }}
      getValidationSchemaFunc={getValidationSchema}
      {...props}
    >
      <UpdatePresaleLayout onCancel={onCancel} />
    </UpdateForm>
  );
};

export default UpdatePresaleRequestForm;
